var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "no show",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3223 17.4582L4.54177 3.67767C6.26633 2.15477 8.52256 1.22223 11 1.22223C16.3912 1.22223 20.7778 5.60877 20.7778 11C20.7778 13.4762 19.8452 15.7337 18.3223 17.4582ZM1.22223 11C1.22223 8.52256 2.15356 6.26633 3.67767 4.54177L17.4582 18.3223C15.7337 19.8452 13.4762 20.7778 11 20.7778C5.60877 20.7778 1.22223 16.3912 1.22223 11ZM11 0C4.92433 0 0 4.92433 0 11C0 17.0757 4.92433 22 11 22C17.0744 22 22 17.0757 22 11C22 4.92433 17.0744 0 11 0Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledIcon);
export default __webpack_public_path__ + "static/media/Cancelled_icon.9e7dd29eba9ae6167761ef22e5f7d089.svg";
export { ForwardRef as ReactComponent };